<template>
  <div class="step-two">
    <div class="form-group">
      <label>
        7. Total {{createdObject.KPI}} per week
      </label>
      <HotTable :root="salesTableId" ref="salesTableId" :settings="weekSales"></HotTable>
    </div>
    <div>
      <div class="checkbox">
        <input id="Historic" type="checkbox" v-model="createdObject.base_sales_flag" :checked="createdObject.base_sales_flag ? 'checked' : ''">
        <label for="Historic">Historic Sales Data</label>
      </div>

    </div>
    <div v-bind:class="{ 'invalid-field': (!validate['step2']) }" v-bind:id="checkValidate = validate['step2']">
      <p class="error-msg">Please add valid entry in above table.</p>
    </div>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<script>
import HotTable from 'vue-handsontable-official'
import Simplert from 'vue2-simplert'

export default {
  components: {
    HotTable,
    Simplert
  },
  props: ['inputData', 'createdObject', 'validate', 'viewObject', 'modelType'],
  data () {
    return {
      totalWeek: this.createdObject.total_weekly_sales['table-data'],
      salesTableId: 'week-sales',
      checkValidate: '',
      base_sales_flag: false,
      weekSales: {
        autoWrapRow: true,
        height: 287,
        colWidths: 120,
        maxColsNumber: 2,
        data: [],
        allowInsertRow: false,
        colHeaders: ['Week No.', 'Total ' + this.createdObject.KPI],
        fillHandle: {
          autoInsertRow: false
        },
        className: 'esheetclass view-only',
        tableClassName: 'exceltablestyle createtable',
        afterChange: this.perWeekChanged,
        beforePaste: this.weekPaste,
        invalidCellClassName: 'htInvalid',
        columns: [
          {
            data: 'name',
            readOnly: true
          },
          {
            validator: /^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:(\.|,)\d+)?$/
          }
        ]
      }
    }
  },
  created () {
    for (var i = 1; i <= 52; i++) {
      this.weekSales.data.push({ name: 'Week ' + i, value: '' })
    }
    if (this.modelType === 'view') {
      this.createdObject.base_sales_flag = this.viewObject.base_sales_flag
      for (let col in this.weekSales.columns) {
        this.weekSales.columns[col].readOnly = true
      }
      for (let week in this.viewObject.Weekly_Sales) {
        this.weekSales.data[week][1] = this.viewObject.Weekly_Sales[week].value.toString()
      }
    }
  },
  activated () {
    this.weekSales.colHeaders = ['Week No.', 'Total ' + this.createdObject.KPI]
    if (!this.validate['step2']) {
      this.$refs.salesTableId.table.validateCells()
    }
    // this,createdObject.base_sales_flag =
  },
  watch: {
    checkValidate: function (val) {
      if (!val) {
        this.$refs.salesTableId.table.validateCells()
      }
    }
  },
  methods: {
    perWeekChanged (changes, source) {
      this.totalWeek['week_no'] = []
      this.totalWeek['weekly_base_sales'] = []
      for (let week in this.weekSales.data) {
        var sales = this.weekSales.data[week][1]
        if (sales !== undefined && sales !== '') {
          sales = sales.replace(/,/gi, '')
        }
        this.totalWeek['week_no'].push(parseInt(week) + 1)
        this.totalWeek['weekly_base_sales'].push(parseInt(sales))
      }
      if (changes) {
        this.$emit('stepValidate')
      }
    },
    weekPaste (data, coords) {
      if (data.length > 52) {
        let modelCreatedModal = {
          title: '',
          message: 'Please add values for 52 weeks only',
          type: 'error',
          customCloseBtnClass: 'btn btn-primary'
        }
        this.$refs.simplert.openSimplert(modelCreatedModal)
        return false
      } else {
        this.validate['step2'] = true
      }
    }
  }
}
</script>
<style scoped>
.step-two .checkbox {
  margin-left: 20px;
  margin-bottom: 20px;
}

.step-two .checkbox label {
  padding-left: 0px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// Model-two.vue?69d28484